// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".period-picker[data-v-549ed669]{position:relative;min-width:140px}", ""]);
// Exports
module.exports = exports;
